export let CreditCardType;

(function (CreditCardType) {
  CreditCardType["Visa"] = "visa";
  CreditCardType["Mastercard"] = "mastercard";
  CreditCardType["DinersClub"] = "diners_club";
  CreditCardType["AmericanExpress"] = "american_express";
  CreditCardType["Discover"] = "discover";
  CreditCardType["JCB"] = "jcb";
  CreditCardType["BCMC"] = "bcmc";
  CreditCardType["Maestro"] = "maestro";
  CreditCardType["CartesBancaires"] = "cartes_bancaires";
  CreditCardType["Unknown"] = "unknown";
})(CreditCardType || (CreditCardType = {}));

export let DisplayedCardBrandName;

(function (DisplayedCardBrandName) {
  DisplayedCardBrandName["JCB"] = "JCB";
  DisplayedCardBrandName["Visa"] = "Visa";
  DisplayedCardBrandName["BCMC"] = "Mastercard";
  DisplayedCardBrandName["Mastercard"] = "Mastercard";
  DisplayedCardBrandName["DinersClub"] = "Diners Club";
  DisplayedCardBrandName["AmericanExpress"] = "American Express";
  DisplayedCardBrandName["CartesBancaires"] = "Cartes Bancaires";
  DisplayedCardBrandName["Unknown"] = "Unknown";
})(DisplayedCardBrandName || (DisplayedCardBrandName = {}));

export let CreditCardRequiredField;

(function (CreditCardRequiredField) {
  CreditCardRequiredField["PostalCode"] = "postal_code";
})(CreditCardRequiredField || (CreditCardRequiredField = {}));

export let CreditCardAddReturnResult;

(function (CreditCardAddReturnResult) {
  CreditCardAddReturnResult["Success"] = "success";
  CreditCardAddReturnResult["Fail"] = "fail";
})(CreditCardAddReturnResult || (CreditCardAddReturnResult = {}));

export let CreditCardAddSourceEntityType;

(function (CreditCardAddSourceEntityType) {
  CreditCardAddSourceEntityType["Unknown"] = "unknown";
  CreditCardAddSourceEntityType["Transaction"] = "transaction";
  CreditCardAddSourceEntityType["PaymentSettings"] = "payment_settings";
  CreditCardAddSourceEntityType["NewPushUpOrder"] = "new_push_up_order";
  CreditCardAddSourceEntityType["ItemPushUpOrder"] = "item_push_up_order";
  CreditCardAddSourceEntityType["ProfilePushUpOrder"] = "profile_push_up_order";
  CreditCardAddSourceEntityType["MainClosetPromotion"] = "main_closet_promotion";
  CreditCardAddSourceEntityType["ProfileClosetPromotion"] = "profile_closet_promotion";
  CreditCardAddSourceEntityType["DirectDonationOrder"] = "direct_donation_order";
  CreditCardAddSourceEntityType["WebviewDirectDonationOrder"] = "webview_direct_donation_order";
  CreditCardAddSourceEntityType["FeaturedCollection"] = "featured_collection";
  CreditCardAddSourceEntityType["ProfileCollections"] = "profile_collections";
  CreditCardAddSourceEntityType["CollectionsManagement"] = "collections_management";
  CreditCardAddSourceEntityType["MsgThreadReturnLabelOrder"] = "msg_thread_return_label_order";
  CreditCardAddSourceEntityType["ComplaintReturnLabelOrder"] = "complaint_return_label_order";
})(CreditCardAddSourceEntityType || (CreditCardAddSourceEntityType = {}));